export function parseDataset(dataset: DOMStringMap) {
  const { x, y } = dataset

  return {
    x: parseFloat(x || '0'),
    y: parseFloat(y || '0')
  }
}